// extracted by mini-css-extract-plugin
export var aboutBanner = "styles-module__aboutBanner___lQQzv";
export var boldSubHeader = "styles-module__boldSubHeader___lfGrf";
export var container = "styles-module__container____H2NC";
export var greenHeader = "styles-module__greenHeader___IHgzD";
export var header = "styles-module__header___x_o4e";
export var subHeader = "styles-module__subHeader___E8KyL";